import http from '../../http';
import { SERVER_URL } from '../../config';

export const getPurchasesData = (params) => http.get(`${SERVER_URL}/api-main/v1/purchases`, {params : { ...params }});
